import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const reasons = [{
  title: "El 'Tiempo Fuera' tradicional",
  desc: 'Solo aumenta el sentimiento de abandono y estrés sensorial, haciendo que la próxima crisis sea más fuerte.'
}, {
  title: 'Razonar durante el colapso',
  desc: 'Es biológicamente imposible. El córtex prefrontal (la parte lógica) se apaga durante una crisis. Estás hablando a una pared.'
}, {
  title: 'Gritar más fuerte',
  desc: 'Solo confirma a los sensores de peligro de tu hijo que el ambiente es hostil, disparando aún más adrenalina.'
}, {
  title: 'Ceder a sus deseos',
  desc: 'Esto no calma su sistema nervioso; solo le enseña que el caos es una herramienta de negociación, pero el estrés interno permanece.'
}];
export function WhyFailed() {
  return <section className="py-20 bg-white px-6" data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-231">
            Por qué lo que has intentado no funciona
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-232">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-coral-light/50 p-8 rounded-2xl border border-brand-coral/10" data-id="element-233">
              <div className="flex items-start gap-4" data-id="element-234">
                <XCircle className="text-brand-coral shrink-0 mt-1" size={24} data-id="element-235" />
                <div data-id="element-236">
                  <h3 className="font-bold text-xl mb-2" data-id="element-237">{reason.title}</h3>
                  <p className="text-brand-navy/80 leading-relaxed" data-id="element-238">
                    {reason.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}